import React from 'react';
import PropTypes from 'prop-types';

const QuestionHeader = ({ number, name }) => (
  <h3>{number}. {name}</h3>
);

QuestionHeader.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default QuestionHeader;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/QuestionHeader.js